/*
 * @Author: your name
 * @Date: 2021-07-08 10:16:41
 * @LastEditTime: 2021-09-07 14:34:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \foxit_print\src\api\config.js
 */
export default {
  method: "get",
  // 请求头信息
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
  },
  // 参数
  data: {},
  // 设置超时时间
  timeout: 22000,
  // 携带凭证
  withCredentials: true,
  // 返回数据类型
  responseType: "json",
  retry: 4,
  retryDelay: 1000
};
